export default "__VITE_ASSET__DInr_6Ca__"